export default (client) => {
  return {
    fetchRows({ viewId, limit = 1000, offset = 0 }) {
      return client.get(`/database/views/keyoflife-kanban/${viewId}/`, {
        params: { limit, offset },
      })
    },
  }
}
